import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Cotizacion {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/cotizacion/create`,
            form,
            headers: headers
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/cotizacion/update`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0) {
        const response = await Api.get({
            url: `${Backend}/cotizacion/list/${page}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getState(page = 0, state = 0, form) {
        const response = await Api.post({
            url: `${Backend}/cotizacion/state/${page}/${state}`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/cotizacion/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async saveService(form) {
        const response = await Api.post({
            url: `${Backend}/cotizacion/service`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async doc(id) {
        const response = await Api.get({
            url: `${Backend}/cotizacion/doc/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
